import { getObjectKeysAsObject } from "@capone/checkout";
import { validateAdditionalDetailsService } from "./validateAdditionalDetails";

export const services = {
  validateAdditionalDetailsService,
};

export const ServiceTypes = getObjectKeysAsObject(services);
